import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import RestService from 'src/app/utils/restservice';

@Injectable({
  providedIn: 'root'
})
export class UbigeoService {

  constructor(private http: HttpClient, private restService: RestService) {}

  departments(params: string = '') {
    let val_params = params != null ? '?' + params : '';
    return this.restService.all('config/ubigeo/departments', val_params);
  }

  provinces(val_id: number) {
    return this.restService.get('config/ubigeo/provinces', val_id);
  }

  districts(val_id: number) {
    return this.restService.get('config/ubigeo/districts', val_id);
  } 
  
}
